const recipesComponentMapping = (data) => {
    const mappedData = {};

    mappedData.title = data?.field_title[0]?.value;
    mappedData.recipeCTA = data?.field_recipe_cta[0]?.value;
    mappedData.recipesPageCTA = data?.field_recipes_page_cta[0]?.value;

    return mappedData;
}

export default recipesComponentMapping;
